import { render, staticRenderFns } from "./SfMenuItem.vue?vue&type=template&id=9977ff80&"
import script from "./SfMenuItem.vue?vue&type=script&lang=js&"
export * from "./SfMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SfMenuItem.vue?vue&type=style&index=0&id=9977ff80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports